import actions from './actions';
import initialState from '../../initialState';

export const levelReducer = (state = initialState.levels, action) => {
    switch (action.type) {
        case actions.SET_LEVEL_MODAL:
            return { ...state, levelModal: action.state.levelModal };
        default:
            return { ...state };
    }
};

export default levelReducer;
